import {Component, OnInit} from '@angular/core';
import {BeneficiarioService} from '../../services/beneficiario.service';
import {first} from 'rxjs/operators';
import {MessageService} from 'primeng/api';
import {Router} from '@angular/router';
import {AutenticacaoService} from 'src/app/services/autenticacao.service';
import {FormBuilder} from '@angular/forms';
import {SharedService} from "../../services/shared.service";

@Component({
  selector: 'app-selecionar-beneficiario',
  templateUrl: './selecionar-beneficiario.component.html',
  styleUrls: ['./selecionar-beneficiario.component.scss'],
  providers: [BeneficiarioService, MessageService]
})
export class SelecionarBeneficiarioComponent implements OnInit {
  loading: boolean;
  cdPessoa: any;
  listaBeneficiarios: [] = [];

  constructor(private beneficiarioService: BeneficiarioService, private autenticacaoService: AutenticacaoService,
              private router: Router, private messageService: MessageService, private fb: FormBuilder,
              private sharedService: SharedService) {
  }

  ngOnInit() {
    this.loading = false;
    this.cdPessoa = this.sharedService.beneficiario.cdPessoa;
    this.buscaBeneficiarios();
  }

  buscaBeneficiarios() {
    this.loading = true;
    this.beneficiarioService.buscaBeneficiarios(this.cdPessoa).pipe(first()).subscribe(beneficiarios => {
        this.loading = false;
        return this.updateListaBeneficiarios(beneficiarios);
      },
      error => {
        this.loading = false;
        if (error === 'Unknown Error' || error === 'ERR_CONNECTION_REFUSED') {
          this.messageService.add(
            {
              severity: 'error',
              summary: 'Ops... Erro no servidor. Tente novamente em alguns instantes!',
              life: 9999999
            }
          );
        } else {
          this.messageService.add({severity: 'warn', summary: 'Erro ao listar beneficiários!', life: 6000});
        }
      }
    );
  }

  updateListaBeneficiarios(beneficiarios) {
    this.listaBeneficiarios = beneficiarios;
  }

  redirecinaSolicitacoes(beneficiario) {
    this.sharedService.beneficiarioSelecionado = beneficiario;
    localStorage.removeItem('currentUser');
    localStorage.setItem('currentUser', JSON.stringify(this.sharedService.beneficiarioSelecionado));
    this.sharedService.visualizaListaSolicitacoes = false;
    this.router.navigate(['/solicitacoes']);
  }

  logout() {
    var businessId = this.autenticacaoService.logout();
    this.router.navigate(['/login'],{queryParams:{cod_empresa:businessId}});
  }
}
